<template>
    <div>
        <Nuxt />
        <UILoader />
    </div>
</template>

<script>
import {defineComponent, useMeta, useRoute, onMounted, watch} from '@nuxtjs/composition-api';

import {useLastRefererCookie} from '@/core/composables/useCookie';
import {useLayoutHead} from '@/core/composables/useLayoutHead';
import UILoader from '@/components/UI-components/Loader/Loader.vue';

export default defineComponent({
    name: 'EmptyLayout',
    components: {
        UILoader,
    },
    setup() {
        const route = useRoute();

        const {getHeadMetaForPage} = useLayoutHead();
        const {initLastRefererCookie} = useLastRefererCookie();

        const headMeta = useMeta();

        onMounted(initLastRefererCookie);

        watch(route, (newRoute) => {
            const meta = getHeadMetaForPage(newRoute.path);

            Object.entries(meta).forEach(([key, value]) => {
                if (key in headMeta) {
                    headMeta[key].value = value;
                }
            });
        }, {immediate: true});

        return {
            headMeta,
            getHeadMetaForPage,
        };
    },
    head: {},
});
</script>
